import { Box, Checkbox, Group, Tooltip } from "@mantine/core"
import { useContext, useEffect, useState } from "react";
import FiltersAndSegmentsContext from "../../FiltersAndSegmentsContext";

const CheckboxCell = ( { id, name, page, isChecked } : { id: number, name: string, page: string, isChecked: boolean } ) => {

  const { handleToggleFilterInPage } = useContext(FiltersAndSegmentsContext)
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if
    ((page === 'perspective' && id === 1)
             || 
             (page === 'customer360' && id === 1)){
      setChecked(false) 
      setDisabled(true)  
    }
    else{
      setChecked(isChecked) 
    }
    
  }, [isChecked, page, id]);

  return (
    <Box 
      component="span" 
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40px',
       
      }}
    >
      <Tooltip disabled={!disabled} label='N/A'>
        <Group spacing="xs" position="center">
          <Checkbox 
            disabled={disabled}
            checked={checked} 
            onChange={(event) => {
              setChecked(event.currentTarget.checked)
              handleToggleFilterInPage(name, id, page, checked)
            }}
            size="md"
            color="indigo"
          />
        
        </Group>
      </Tooltip>
      
    </Box>
  )
}

export default CheckboxCell